export const ls = {
  get: <T,>(key: string, fallback: T): T => {
    try {
      const raw = localStorage.getItem(key);
      return raw ? (JSON.parse(raw) as T) : fallback;
    } catch (e) {
      return fallback;
    }
  },
  has: (key: string): boolean => {
    try {
      return localStorage.getItem(key) !== null;
    } catch (_) {
      return false;
    }
  },
  set: (key: string, val: any) => {
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (_) {
      // ignore
    }
  },
};
